import { connect } from 'react-redux'
import Globals from '../../globals'
import * as action from '../state/action'
import * as selector from '../state/selector'
import EmployeeSettings from './EmployeeSettings'


const mapStateToProps = state => {
    return {
        employee: selector.selectEmployee(state),
        sipGateDeviceList: Globals.selector.selectDeviceList(state),
    }
}

const mapDispatchToProps = {
    changeEmployee: action.changeEmployee,
    setSipGateDeviceId: action.setSipGateDeviceId,
}


export default connect(mapStateToProps, mapDispatchToProps)(EmployeeSettings)



// WEBPACK FOOTER //
// ./src/modules/employee/component/EmployeeSettingsContainer.js